"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatOfferAmountEl = formatOfferAmountEl;
exports.ensureOfferAmountLine = ensureOfferAmountLine;
/** Ποσό σε μορφή «220,00 €» για κείμενο προσφοράς. */
function formatOfferAmountEl(amount) {
    return new Intl.NumberFormat('el-GR', {
        style: 'currency',
        currency: 'EUR',
    }).format(amount);
}
function parseOfferAmountValue(amount) {
    if (amount == null || amount === '')
        return null;
    if (typeof amount === 'number') {
        return Number.isFinite(amount) && amount >= 0 ? amount : null;
    }
    const n = Number(String(amount).trim().replace(',', '.'));
    return Number.isFinite(n) && n >= 0 ? n : null;
}
const CLOSING_PARAGRAPH_RE = /Εάν έχετε οποιαδήποτε ερώτηση[\s\S]*?επικοινωνήσετε μαζί μας\.?/i;
/**
 * Βάζει ή ενημερώνει «Ποσό Προσφοράς: …» αμέσως πριν την παράγραφο επικοινωνίας.
 */
function ensureOfferAmountLine(text, amount) {
    const value = parseOfferAmountValue(amount);
    if (value == null)
        return text.trim();
    const amountLine = `Ποσό Προσφοράς: ${formatOfferAmountEl(value)}`;
    let out = text.trim();
    if (/^Ποσό Προσφοράς:/im.test(out)) {
        return out.replace(/^Ποσό Προσφοράς:.*$/im, amountLine);
    }
    if (CLOSING_PARAGRAPH_RE.test(out)) {
        return out.replace(CLOSING_PARAGRAPH_RE, `${amountLine}\n\n$&`);
    }
    const shortClosingRe = /Εάν έχετε οποιαδήποτε ερώτηση/i;
    if (shortClosingRe.test(out)) {
        return out.replace(shortClosingRe, `${amountLine}\n\n$&`);
    }
    return `${out}\n\n${amountLine}`;
}
